import React, { useState } from 'react'
import Button from '../../components/General/Button'
import InputUpload from '../../components/Inputs/InputUpload'

interface IKYCForm {
  isKYCLoading: boolean
  onSubmitKYC: (image: any) => void
}

const KYCForm: React.FC<IKYCForm> = ({ isKYCLoading, onSubmitKYC }) => {
  const [imageKYC, setImageKYC] = useState<any>(null)

  const onSubmit = () => {
    onSubmitKYC(imageKYC)
  }

  return (
    <>
      <div>
        <h1 className="text-center">Verificación legal</h1>

        <p className="mt-5 text-center font-normal text-gray-400 text-sm">
          Para cumplir con la normativa del SENIAT y activar tu cuenta, completa
          la verificación legal. Debes subir una foto legible en formato PNG o
          JPEG de un documento que identifique tu negocio: RIF Jurídico, RIF
          Personal o, en su ausencia, Cédula de Identidad.{' '}
        </p>
      </div>

      <div className="mt-5 flex flex-col items-center">
        <InputUpload
          isCompressed={true}
          title="Sube el documento"
          fileType="image"
          handleImage={(img) => {
            setImageKYC(img)
          }}
          deleteImage={() => {
            setImageKYC(null)
          }}
          // containerClasses="xl:col-start-1 xl:row-span-3 xl:col-span-3 col-start-3 col-span-8 row-span-8 m-auto"
          imageClasses="rounded-md dark:border-gray-700"
          maxHeight="max-h-[250px]"
          size={6000000}
        />

        <div className="mt-5 flex flex-row items-center justify-center w-full">
          <Button
            type="primary"
            loading={isKYCLoading}
            disabled={isKYCLoading}
            onClick={() => {
              onSubmit()
            }}
          >
            Verificar
          </Button>
        </div>
      </div>
    </>
  )
}

export default KYCForm
